<template>
  <div class="search-cont per-cert">
    <div class="zhezhao"></div>
    <div class="publish">
      <ul class="account-data">
        <li>
          <label>帐号名称</label>
          <input type="text" v-model="accountName" placeholder="请输入" />
          <p class="note">
            2-10个字，请勿使用含特殊符号或含有明显营销推广意图的媒体名。见
            <span>《头条号名称注册规范》</span>
          </p>
        </li>
        <li>
          <label>帐号介绍</label>
          <textarea v-model="accountIntroduce"></textarea>
          <p class="note">10-30个字，要求内容完整通顺，无特殊符号请勿添加任何联系方式如微博、手机号。</p>
        </li>
        <li class="icon">
          <label>帐号头像</label>
          <div class="icon-img">
            <img :src="accountPic" alt />
          </div>
          <div class="upload-note">
            <label class="upload-btn" for="input">上传图片</label>
            <input type="file" id="input" @change="getFile($event)" hidden />
            <p class="require">要求清晰、健康、代表品牌形象</p>
            <p>请勿使用二维码，最大5M,200x200像素</p>
          </div>
        </li>
        <li>
          <label>运营者姓名</label>
          <input type="text" placeholder="请输入" v-model="operatorName" />
          <p class="note">请务必与上传的身份证件保持一致</p>
        </li>
        <li>
          <label>运营者身份证号</label>
          <input type="text" placeholder="请输入" v-model="operatorIdNumber" />
          <p class="note">请务必与上传的身份证件保持一致</p>
        </li>
        <li class="icon">
          <label>运营者身份证照片</label>
          <div class="icon-img">
            <img :src="operatorIdPic" alt />
          </div>
          <div class="upload-note">
            <label class="upload-btn" for="Idcard">上传图片</label>
            <input type="file" id="Idcard" @change="getsIdcard($event)" hidden />
            <p class="exam">
              请
              <span>参照事例</span>手持身份证件拍摄
            </p>
            <p class="require">要求清晰、健康、代表品牌形象</p>
            <p>请勿使用二维码，最大5M,200x200像素</p>
          </div>
        </li>
        <li>
          <label>联系邮箱</label>
          <input type="text" v-model="email" placeholder="请输入" />
        </li>
      </ul>
      <p class="agree">
        <i :class="['iconfont', isActive?'active':'']" @click="agreement"></i>请同意
        <span>《头条号用户注册协议》</span>
      </p>
      <div class="save-btn">
        <div class="btn-list" @click="back">上一步</div>
        <div class="btn-list active" @click="submitData">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      isActive: false,
      value: "",
      accountName: "",
      accountIntroduce: "",
      accountPic: require("../../assets/img/bg.png"),
      operatorName: "",
      operatorIdNumber: "",
      operatorIdPic: require("../../assets/img/card.png"),
      email: ""
    };
  },
  mounted() {},
  methods: {
    back() {
      this.$parent.name = "authentic";
    },
    agreement() {
      this.isActive = !this.isActive;
    },
    getFile(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "http://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.accountPic = res.data.url;
        }
      });
    },
    getsIdcard(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "http://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.operatorIdPic = res.data.url;
        }
      });
    },
    submitData() {
      //媒体认证
      if (this.accountPic.indexOf("data:") == 0) {
        this.accountPic = "";
      }
      this.$http
        .get("/api/media/001-mediaCertificationSave", {
          params: {
            type: 1,
            accountName: this.accountName,
            accountIntroduce: this.accountIntroduce,
            accountPic: this.accountPic,
            operatorName: this.operatorName,
            operatorIdNumber: this.operatorIdNumber,
            operatorIdPic: this.operatorIdPic,
            email: this.email,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "发布");
          if (res.data.code == 0) {
            this.$message("提交成功");
            this.$store.commit("userPerson", { a: false });
            this.$store.commit("choicePersonal", { as: false });
            var self = this;
            setTimeout(function() {
              self.$parent.$data.panelModal = false;
            }, 300);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
input {
  cursor: pointer;
}
.search-cont .center .cont-right .close {
  width: 20px;
  height: 20px;
}
.close:hover,
.close {
  opacity: 1;
}
.zhezhao {
  background: rgba(255, 255, 255, 1);
}
.per-cert .account-data li.network label {
  padding-left: 15px;
}
.per-cert .account-data li.network label::before {
  display: none;
}
.per-cert .account-data li .upload-note .upload-btn {
  padding-top: 0px;
  text-align: center;
}
.per-cert .account-data li .upload-note .upload-btn::before {
  display: none;
}
.per-cert .account-data li input {
  margin-left: 0px;
}
</style>

